import React, { useState, useEffect, useContext, Component,useMemo } from "react";

import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";
import axiosInstance, { LiveURL, weburl } from "../../../axiosInstance";

import Footer from "../../components/Footer";
import Header from "../../components/Header";
import LoadingScreen from "../../components/LoadingScreen";
import getDecryptData from "../../../helper/getDecryptData";
import getCookie from "../../../helper/getCookie";
import moment from 'moment'; // To handle date manipulation
import LoginComponents from "../../components/LoginComponents";
 import { useBlogContext } from "../../../fetchdata/BlogContext";
import { Swiper, SwiperSlide } from "swiper/react";
 
// import required modules
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";
import { SchedulePicker } from "../../components/SchedulePicker";


function to24Hour(t) {
  let [time, modifier] = t.trim().split(" ");
  let [hours, minutes] = time.split(":");

  hours = parseInt(hours, 10);

  if (modifier === "PM" && hours !== 12) {
    hours += 12;
  }
  if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  return `${hours.toString().padStart(2, "0")}:${minutes}`;
}


const ViewVendor = ({updateAuthStatus}) => {
   

    const [AddProduct, setAddProduct] = useState([]);
  


  const navigate = useNavigate();

  const [isUserAuthenticated, setisUserAuthenticated] = useState(false);

  const handleAuthUpdate = (value) => {
    if (typeof updateAuthStatus === 'function') {
      updateAuthStatus(value);
    }
    setisUserAuthenticated(value);

    if (value) {
      const user = getDecryptData();
      setIsUser(user);
      if (user) {
        setEnquireData((prevData) => ({
          ...prevData,
          id: user._id || prevData._id,
          name: user.username || prevData.fullname,
          email: user.email || prevData.email,
          phone: user.phone || prevData.phone,
        }));
      }
    } else {
      setIsUser(null);
      setEnquireData((prevData) => ({
        ...prevData,
        fullname: '',
        email: '',
        phone: '',
      }));
    }
  };

    const  {getAuth , sendMessage, allMessages} = useBlogContext();

const getNext8Days = () => {
  let days = [];
  let today = new Date();

  for (let i = 0; i < 10; i++) {
    let d = new Date();
    d.setDate(today.getDate() + i);
    days.push({
      date: d.toISOString().split("T")[0],  // yyyy-mm-dd
      dayName: d.toLocaleString("en-US", { weekday: "long" }),
    });
  }

  return days;
};

  const [formData, setFormData] = useState({
    hospitalId: null,
    day: null,
    currentRange: 0 // Keeps track of which range of 3 days to display
  });

 
const [isuser, setIsUser] = useState(null);

useEffect(() => {
  const user = getDecryptData();
  setIsUser(user);
  setUserId(user?._id || null);
}, []); // runs only once

 
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const [EnquireShow, setEnquireShow] = useState(false);
  const [enquireData, setEnquireData] = useState([]);
    const [clinicData, setClinicData] = useState([]);


  const [CardShow, setCardShow] = useState(false);


  const [EnquireStatus, setEnquireStatus] = useState(false);

  const enquireToggle = async () => {
    const decryptdatajson = await getDecryptData();
    const email = decryptdatajson?.email;

    if (EnquireShow) {
      setEnquireShow(false);
    } else {
      if (isUserAuthenticated) {
        if (email == undefined) {
          navigate('/account/profile');
          toast.error('Please update your profile')
        } else {
          setEnquireShow(true);
        }
      }
    }
  }

  const enquireCardToggle = () => {

    if (CardShow) {

      setCardShow(false);
    } else {
      if (!isUserAuthenticated) {
        toast.error('Please Login & buy Plan')
      }
      setCardShow(true);
    }
  };


  const [images, SetImages] = useState({});

  const [loading, setloading] = useState(true);

  const [Page, setPage] = useState({});
  const [AllPLan, setAllPlan] = useState([]);
  const [NavigateLogic, setNavigateLogic] = useState(false);

  const [userId, setUserId] = useState(null);
  const [AllRating, setAllRating] = useState([]);

  const averageExternalRating =
    Array.isArray(AllRating) && AllRating.length
      ? AllRating.reduce((sum, item) => sum + Number(item.rating || 0), 0) / AllRating.length
      : null;

  const ratingValue = Number(
    averageExternalRating ?? Page?.rating ?? Page?.ratingAvg ?? Page?.avgRating ?? Page?.reviewScore ?? 5
  );
  const safeRating = Number.isNaN(ratingValue) ? 5 : Math.min(5, Math.max(0, ratingValue));
  const fullStars = Math.floor(safeRating);
  const hasHalfStar = safeRating - fullStars >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  const starsText = "★".repeat(fullStars) + (hasHalfStar ? "" : "") + "☆".repeat(emptyStars);

  const reviewItems =
    Array.isArray(AllRating) && AllRating.length > 0
      ? AllRating
      : Array.isArray(Page?.stories) && Page.stories.length > 0
      ? Page.stories
      : [ ];

  const faqItems =
    Array.isArray(Page?.faq) && Page.faq.length > 0
      ? Page.faq
      : [
          {
            question: "What is the cost of Dental Implants?",
            answer:
              "Costs vary depending on complexity; contact for a personalized quote.",
          },
          {
            question: "Do you offer financing options?",
            answer:
              "Financing and payment plans are available. Please ask the clinic for details.",
          },
          {
            question: "What are your hours?",
            answer: "10:00 AM to 08:00 PM, closed on Monday.",
          },
        ];

  const { id } = useParams();

  const getDoctor = async () => {

    const decryptdatajson = await getDecryptData();
    const senderId = decryptdatajson?._id;

    setloading(true);

    try {
      const { data } = await axiosInstance.get(`/get-vendor/${id}`);
      setPage(data.Mpage);
      console.log(data);
      // Delay the execution of buildScript by 1 secon
       setFormData((prevData) => ({
            ...prevData,
            hospitalId: data.Mpage.headId[0]._id,
        }));
 setClinicData({"headId":data.Mpage.headId,"schedule":data.Mpage.schedule})
      const TotalImages = []; // Start with the sample images array

      // Add more images conditionally based on `data.Mpage`
      if (data.Mpage.profile) {
        TotalImages.push(weburl + data.Mpage.profile.replace("public", ""));
      }

      if (data.Mpage.AccreditationCertificateFile) {
        TotalImages.push(
          weburl + data.Mpage.AccreditationCertificateFile.replace("public", "")
        );
      }
      SetImages(TotalImages);

      setEnquireData((prevData) => ({
        ...prevData,
        userId: data.Mpage._id,
        senderId: senderId,
      }));

              setAddProduct( [    {
    "_id": "1234567890",
    "title": "Appointment Consultation",
    "slug": "appointment_consultation",
    "regularPrice": null,
    "salePrice": data?.Mpage?.Salary,
    "stock": 100,
    "reStock": 100,
    "serialNumber": 1,
    "brandName": "Appointment Consultation",
    "protype": 1,
    "gst": 12,
    "Rentalgst": 12,
    "quantity": 1,
    "amount": 0,
    "total": 0,
    "tax": 12
}] )

    } catch (error) {
      console.log(error);
      // toast.error("Error fetching Single Blog!");
    } finally {
      setloading(false);
    }
  };

  const getRatings = async () => {
    try {
      const { data } = await axiosInstance.get(`/view-product-rating/${id}`);
      setAllRating(Array.isArray(data.productRatings) ? data.productRatings : []);
    } catch (error) {
      console.error("Error fetching ratings:", error);
    }
  };

  const submitData = async () => {
    setSubmitLoading(false);

    if (!userId) {
      toast.error("Please Login First");
      setSubmitLoading(true);
      return;
    }

    if (!formData.rating || !formData.comment) {
      toast.error("Please Fill All Fields");
      setSubmitLoading(true);
      return;
    }

    try {
      await axiosInstance.post("/add-rating", {
        userId,
        productId: Page._id,
        rating: Number(formData.rating),
        comment: formData.comment,
      });
      toast.success("Rating Added successfully!");
      setFormData((prev) => ({ ...prev, rating: "", comment: "" }));
      getRatings();
      toggleReviewPopup();
    } catch (error) {
      console.error("Error on rating added:", error);
      toast.error(error?.response?.data?.message || "Error adding review.");
    } finally {
      setSubmitLoading(true);
    }
  };

  const GetUserPlan = async () => {
    if(!isUserAuthenticated){
      return;
    }
    try {
      const decryptdatajson = await getDecryptData();
      const Id = decryptdatajson?._id;

      const response = await axiosInstance.get(`check-plan-user/${Id}`);

      const { success, message , data} = response.data;

      if (success) {
        setAllPlan(data||[]);
        if(data.length !== 0){
           const firstPlan = data[0];
          setFormData((prevData) => ({
            ...prevData,
            planId: firstPlan._id
        }));
        setEnquireData((prevData) => ({
          ...prevData,
          fullname: firstPlan?.details?.fullname,
          email: firstPlan?.details?.email,
          phone: firstPlan?.details?.phone,
      }));

      
        }
     

    
      } else {
        // toast.error(message)
        // navigate('/all-plan')
        setNavigateLogic(true);
      }

      console.log('response.data',response.data)

    } catch (error) {
      console.log(error);
      // navigate('/all-plan');
      setNavigateLogic(true);
      // toast.error("Error fetching Single Blog!");
    }
  }


        const [allBookings, setAllBookings] = useState([]);
  
           const [loadingBookings, setLoadingBookings] = useState(false);
  
  const FetchDoctorBookChange = async (myid, doctorId = Page?._id) => { 

         try { 
       if (!myid || !doctorId) return;
       setLoadingBookings(true);
      const response = await axiosInstance.get(`/get-vendor-slot?doc=${doctorId}&days=10&hos=${myid}`);
      const { success, schedule } = response.data;
      if (success) {
     setAllBookings(schedule ?? []);
        } 
  
    } catch (error) {
      console.error('Error fetching bookings:', error);
  
    }finally{
     setLoadingBookings(false);
    }


    //  try {
   
    //   const startDate =  dates[0]?.value;
    //    const endDate =  dates[dates.length - 1]?.value;
  
    //    setLoadingBookings(true);
    //   const response = await axiosInstance.get(`/admin/all-booking?search=&limit=200startDate=${startDate}&endDate=${endDate}&status=&productId=&type=3&userId=${myid}`);
    //   const { success, Order } = response.data;
    //   if (success) {
    //  setAllBookings(Order ?? []);
    //     } 
  
    // } catch (error) {
    //   console.error('Error fetching bookings:', error);
  
    // }finally{
    //  setLoadingBookings(false);
    // }
   
  };
  

  
   useEffect(() => {
    if(formData.hospitalId && Page?._id){
      FetchDoctorBookChange(formData.hospitalId, Page._id);
    }
  }, [formData.hospitalId, Page?._id]);


  useEffect(() => {
    getDoctor();
    getRatings();
    GetUserPlan();
    window.scrollTo(0, 0);
  }, [id]);

 
    useEffect(() => {
if(isuser){
  setEnquireData((prevData) => ({
      ...prevData,
      name: isuser.username,
       email: isuser.email,
        phone: isuser.phone,
        id: isuser._id
    }));
 }
  }, [isuser]);



 
  const validate = (email) => {
    // Regular expression to check for invalid characters
    const invalidCharsRegex = /[^\w@_.]| /; // Disallow spaces and any character that's not a word character, @, or .

    // Check for invalid cases
    if (email === "-" || email === "+") {
      return "";
    } else if (invalidCharsRegex.test(email)) {
      return ""; // Return empty string if invalid characters (including spaces) are found
    } else {
      return email; // Return the original email if valid
    }
  };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    str = str.replace(/\d+/g, "");
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handleEnquireChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Determine the new value based on input type
    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    // Capitalize each word for specific fields
    if (name === "fullname") {
      newValue = capitalizeEachWord(newValue);
    }

    if (name === "email") {
      newValue = validate(newValue);
    }

    if (name === "phone") {
      // Replace non-digit characters
      newValue = value.replace(/\D/g, ""); // This allows only digits
      if (newValue.length > 10) {
        newValue = newValue.slice(0, 10); // Limit to 10 digits
      }
    }

    // Update form data with the new value
    setEnquireData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if(name === 'planId'){
      const foundPlan = AllPLan.find(AllPLan => AllPLan._id === value);
      if(foundPlan){
        setEnquireData((prevData) => ({
          ...prevData,
          fullname : foundPlan?.details?.fullname,
          email : foundPlan?.details?.email,
          phone : foundPlan?.details?.phone,

        }));
      } 

    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  
  const [isOpenReview, setIsOpenReview] = useState(false);
  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
    const [submitAppointmentLoading, setSubmitAppointmentLoading] = useState(false); // Add loading state


  const handleSendEnquire = async (name, Id, userEmail,userPhone) => {

    if(NavigateLogic){
        navigate('/all-plan');
        return;
    }
    const fields = [
      { name: "fullname", message: "Please enter Full Name" },
      { name: "phone", message: "Please enter phone number" },
      { name: "email", message: "Please enter email" },
      { name: "age", message: "Please enter email" },
      { name: "weight", message: "Please enter weight" },
      { name: "gender", message: "Please select gender" },
       { name: "requirement", message: "Please enter requirement" },
    ];

    for (const field of fields) {
      if (!enquireData[field.name]) {
        toast.error(field.message);
        setEnquireStatus(false);
        return;
      }
    }

    // Clear form fields

    const updatedFormData = {
      ...enquireData,
      userId: Id || null,
      userEmail: userEmail || null,
      userPhone: userPhone || null,
      type: 1,
      name,
      planId: formData.planId
    };

    try {
      setEnquireStatus(true);

      const { data } = await axiosInstance.post(`/send-enquire-vendor`, updatedFormData);


      // setEnquireData((prevData) => ({
      //   ...prevData,
      //   fullname: "",
      //   email: "",
      //   phone: "",
      //   service: "",
      //   QTY: "",
      //   requirement: "",
      //   type:1
      // })); // Clear form fields


      const { success, message } = data;

      if (success) {
        toast.success('Enquire Submit !successfully');
        enquireToggle();
        navigate('/account/all-enquire');
      } else {
        toast.error(message)
        enquireToggle();
        enquireCardToggle();
      }
      console.log('reresponsesponse', data)


    } catch (error) {
      console.error("Failed to send email:", error);
      // toast.error('Failed to send email');
    } finally {
      setEnquireStatus(false);
    }
  };

  const toggleReviewPopup = () => {
    if (!userId) {
      toast.error("Please Login First");
      return;
    }
    setIsOpenReview(!isOpenReview);
  };

  const [ChooseDateTime, setChooseDateTime] = useState(false);
  const dateTimeToggle = () => setChooseDateTime((s) => !s);

  // Config states (kept names from your code)
  const [ExtendDate, setExtendDate] = useState(6);            // days to generate
  const [StartTime, setStartTime] = useState("T10:00:00");    // fallback start (unused if shifts provided)
  const [EndTime, setEndTime] = useState("T20:00:00");        // fallback end (unused if shifts provided)
  const [TimeGap, setTimeGap] = useState(30);                 // minutes step
  const [roundOffTime, setroundOffTime] = useState("Yes");    // "Yes" | "No"
  const [startingHour, setStartingHour] = useState(1);        // minutes-from-now buffer for "today"

  // Parse helper for "10AM", "11:30AM", etc.
  const parse12h = (hh = "") => {
    const m = hh.trim().toUpperCase().match(/^(\d{1,2})(?::(\d{2}))?(AM|PM)$/);
    if (!m) return null;
    let [, hStr, minStr, ap] = m;
    let h = parseInt(hStr, 10);
    const mins = minStr ? parseInt(minStr, 10) : 0;
    if (ap === "AM") {
      if (h === 12) h = 0;
    } else {
      if (h !== 12) h += 12;
    }
    return { hour: h, minute: mins };
  };

  const roundToNextInterval = (d, gapMins) => {
    const date = new Date(d);
    const mins = date.getMinutes();
    const remainder = mins % gapMins;
    if (remainder !== 0) date.setMinutes(mins + (gapMins - remainder));
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  };

  const formatAMPM = (date) => {
    let h = date.getHours();
    let m = date.getMinutes();
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    const mm = m < 10 ? `0${m}` : `${m}`;
    return `${h}:${mm} ${ampm}`;
  };



  const generateDates = () => {
    const days = [];
    const today = new Date();
    for (let i = 0; i < Number(ExtendDate || 0); i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      const options = { weekday: "short", day: "2-digit", month: "short" };
      days.push({
        label: date.toLocaleDateString("en-IN", options), // e.g. Wed, 09 Jul
        value: date.toISOString().split("T")[0],          // yyyy-mm-dd
      });
    }
    return days;
  };

  const dates = useMemo(() => generateDates(), [ExtendDate]);

  // Selected date/time
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedHour, setSelectedHour] = useState(""); // kept from your code; not required
  const selectChangeHour = (hr) => setSelectedHour(`${hr}`);

  const generateTimeSlots = (dateStr) => {
    if (!dateStr) return [];
    const now = new Date();
    const isToday = new Date().toISOString().split("T")[0] === dateStr;
    const gap = Number(TimeGap || 30);

    const earliestToday = (() => {
      if (!isToday) return null;
      const base = new Date();
      // startingHour used as "minutes-from-now" buffer for 'today'
      base.setMinutes(base.getMinutes() + Number(startingHour || 0));
      return roundOffTime === "Yes" ? roundToNextInterval(base, gap) : base;
    })();

    const slots = [];
    const useShifts = Array.isArray(Page?.Shift) && Page.Shift.length > 0;

    if (useShifts) {
      for (const range of Page.Shift) {
        const [rawStart, rawEnd] = String(range).split("-").map((s) => s.trim());
        const ps = parse12h(rawStart);
        const pe = parse12h(rawEnd);
        if (!ps || !pe) continue;

        const start = new Date(`${dateStr}T00:00:00`);
        start.setHours(ps.hour, ps.minute, 0, 0);

        const end = new Date(`${dateStr}T00:00:00`);
        end.setHours(pe.hour, pe.minute, 0, 0);

        // starting point
        let current = new Date(start);
        if (isToday) {
          const minStart = earliestToday
            ? new Date(Math.max(earliestToday.getTime(), start.getTime()))
            : start;
          current = roundOffTime === "Yes" ? roundToNextInterval(minStart, gap) : minStart;
        }

        // inclusive end: push times up to end
        while (current <= end) {
          if (!isToday || current >= now) {
            slots.push(formatAMPM(current));
          }
          current = new Date(current.getTime() + gap * 60000);
        }
      }
    } else {
      // Fallback to Start/End window if no shifts defined
      if (isToday) {
        const base = new Date();
        base.setMinutes(base.getMinutes() + Number(startingHour || 0));
        const first = roundOffTime === "Yes" ? roundToNextInterval(base, gap) : base;
        let current = new Date(first);
        const end = new Date(dateStr + EndTime);
        while (current <= end) {
          slots.push(formatAMPM(current));
          current = new Date(current.getTime() + gap * 60000);
        }
      } else {
        let current = new Date(dateStr + StartTime);
        const end = new Date(dateStr + EndTime);
        while (current <= end) {
          slots.push(formatAMPM(current));
          current = new Date(current.getTime() + gap * 60000);
        }
      }
    }

    return Array.from(new Set(slots)); // de-dupe, just in case shifts touch
  };
 
 

      const BookAppointment = async () => {

    if (!isuser) {
        toast.error('Please Login First');
        return;
      } 
            const decryptdatajson = getDecryptData();
          if (!decryptdatajson || !decryptdatajson._id) {
            toast.error('User data missing, please login again.');
            setSubmitAppointmentLoading(false);
            return;
          }
         // Prepare data for submission
            const updatedFormData = {
              // ...enquireData,
               UserDetails:enquireData,
               addHistory: [],
              addProduct: AddProduct,
                 addReceived: [],
addRentalL: [],
addReturn: [],
applyCGST: false,
applyIGST: false,
applySGST: false,
date: selectedDate,
discount: 0,
 doctor: 1,
  employeeId: Page._id,
  finalTotal: Page.Salary,
    floor: "",
 hospitalId: formData.hospitalId,

images: [], 
prescription: [], 
room:"",
shipping: 0,
source:"",
status:1,
  subtotal: Page.Salary,
  taxTotal:0,
  userId : null,
  time: selectedTime, 
            };
      console.log('updatedFormData',updatedFormData);
 
   
          if(!selectedDate){
                                 toast.error('Select Date');
                                       return;
                              }
                              if(!selectedTime){
                                toast.error('Select Time');
                                return;
                              }

             setSubmitAppointmentLoading(true);

    

       
            try {

              // return null;

              // Send the data to the backend
              const data = await axiosInstance.post(`/admin/add-booking`, updatedFormData);

              const { success,newOrder } = data.data;
 
            if(success){
   const sendmsg = { 
          ...newOrder,
            type: "appointment",
            subType: "add", 
        }

      sendMessage(sendmsg); 
      
                 toast.success(data.message || "Book appointment successfully");
               navigate('/account/all-order');
       } else {
                 toast.error(data.message || "Something went wrong. Please try again.");
           }


      //          const { success, paymentData } = data.data;
      
      //         if (success) {
      
      // console.log('datadatadatadata',data)
      //           const handlePayment = (paymentData) => {
      //             const form = document.createElement('form');
      //             form.method = 'POST';
      //             form.action = LiveURL; // PayU's secure payment URL
       
      //             Object.keys(paymentData).forEach((key) => {
      //               const input = document.createElement('input');
      //               input.type = 'hidden';
      //               input.name = key;
      //               input.value = paymentData[key];
      //               form.appendChild(input);
      //             });
      
      //             document.body.appendChild(form);
      //             form.submit();
      //           };
      
      //           handlePayment(paymentData);
      //           toast.success("Plan buy Successfully");
      
      //           navigate('/account/plan');
      
      //         } else {
      //           toast.error(data.message || "Something went wrong. Please try again.");
      //         }
              
            } catch (error) {
              console.error("Error On Signup:", error);
            } finally {
              // Stop loading after the submission process finishes
              setSubmitAppointmentLoading(false);
            }
      


    }

      // Set default day (current day) and generate next 8 days
  useEffect(() => {
    // Set the default day to current day
    const currentDay = new Date().toLocaleString("en-US", { weekday: "long" });

    setFormData((prevData) => ({
      ...prevData,
      day: currentDay,
    }));
  }, []);


    // Helper function to get the date and short weekday (e.g., 21, Sat)
  const formatDate = (day) => {
    const today = new Date();
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const shortWeekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    // Find the index of the day in the daysOfWeek array
    const dayIndex = daysOfWeek.indexOf(day);
    
    // Get the date of the day in the next week based on today
    const nextDate = new Date(today);
    nextDate.setDate(today.getDate() + ((dayIndex + 7 - today.getDay()) % 7));

    // Format the date as "21, Sat"
    const date = nextDate.getDate();
    const shortWeekDay = shortWeekDays[dayIndex];

    return `${date}, ${shortWeekDay}`;
  };


  const getBookingsForDate = (date) => {
  const formattedDate = new Date(date).toISOString().split("T")[0];

  return  allBookings.filter((booking) => {
    const bookingDate = new Date(booking.date)
      .toISOString()
      .split("T")[0];

    return bookingDate === formattedDate;
  });
};


  const isMobileScreen = () => {
  return window.innerWidth <= 768; // you can adjust breakpoint (768px = Bootstrap's md)
};
  const [isMobile, setIsMobile] = useState(isMobileScreen());

  useEffect(() => {
    const handleResize = () => setIsMobile(isMobileScreen());
    window.addEventListener("resize", handleResize);

    // Cleanup listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

    const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  

  return (
    <>
      <Header />
      {/* <Helmet>
        <title>{Page.metaTitle}</title>
        <meta name="metaDescription" content={Page.meta_description} />
      </Helmet> */}


{loading ?
 <section className="page-hero py-5">
  <div className="container">

    {/* Breadcrumb */}
        {/* Breadcrumb */}
    <div className="small text-muted mb-3 d-flex gap-2">
      <div className="skeleton skeleton-text" style={{width: "5%"}}></div>
      <div className="skeleton skeleton-text" style={{width: "10%"}}></div>
            <div className="skeleton skeleton-text" style={{width: "20%"}}></div>
    </div>


    <div className="row g-4 align-items-start">

      {/* LEFT: Doctor Info */}
      <div className="col-lg-4">
        <div className="glass p-4">
          {/* Doctor's Image and Basic Info */}
          <div className="d-flex align-items-start gap-3 mb-4">
            <div className="skeleton rounded-circle" style={{width: 80, height: 80}}></div>
            <div>
              <div className="skeleton skeleton-text" style={{width: "70%", height: "20px"}}></div>
              <div className="skeleton skeleton-text" style={{width: "50%", height: "15px"}}></div>
              <div className="skeleton skeleton-text" style={{width: "40%", height: "15px"}}></div>
            </div>
          </div>

          {/* Rating + Experience */}
          <div className="d-flex gap-2 mb-3">
            <div className="skeleton skeleton-text" style={{width: "80px", height: "20px"}}></div>
            <div className="skeleton skeleton-text" style={{width: "100px", height: "20px"}}></div>
            <div className="skeleton skeleton-text" style={{width: "120px", height: "20px"}}></div>
          </div>

          {/* Doctor Description */}
          <div className="fw-semibold mb-2">
            <div className="skeleton skeleton-text" style={{width: "40%", height: "20px"}}></div>
          </div>
          <div className="text-muted small mb-4">
            <div className="skeleton skeleton-text" style={{width: "100%", height: "15px"}}></div>
            <div className="skeleton skeleton-text" style={{width: "100%", height: "15px"}}></div>
            <div className="skeleton skeleton-text" style={{width: "100%", height: "15px"}}></div>
          </div>

          {/* Contact and Call to Action */}
          <div className="d-flex gap-2 flex-wrap">
            <div className="skeleton skeleton-btn" style={{width: "100%", height: "40px"}}></div>
            <div className="skeleton skeleton-btn" style={{width: "100%", height: "40px"}}></div>
          </div>

        </div>
      </div>

      {/* RIGHT: Sticky Sidebar */}
      <div className="col-lg-4">
        <div className="sticky-side">
          <div className="glass p-4">

            <div className="fw-bold" style={{color:"var(--navy)"}}>
              <div className="skeleton skeleton-text" style={{width: "60%", height: "20px"}}></div>
            </div>
            <div className="text-muted small mb-3">
              <div className="skeleton skeleton-text" style={{width: "80%", height: "15px"}}></div>
            </div>

            <div className="row g-2">
              <div className="col-12">
                <div className="skeleton skeleton-input" style={{width: "100%", height: "40px"}}></div>
              </div>
              <div className="col-12">
                <div className="skeleton skeleton-input" style={{width: "100%", height: "40px"}}></div>
              </div>
              <div className="col-12">
                <div className="skeleton skeleton-select" style={{width: "100%", height: "40px"}}></div>
              </div>
              <div className="col-12">
                <div className="skeleton skeleton-select" style={{width: "100%", height: "40px"}}></div>
              </div>
              <div className="col-12">
                <div className="skeleton skeleton-btn" style={{width: "100%", height: "40px"}}></div>
              </div>
            </div>

            <div className="small text-muted mt-3">
              <div className="skeleton skeleton-text" style={{width: "100%", height: "15px"}}></div>
            </div>

          </div>
        </div>
      </div>

      {/* CENTER: Doctor Gallery */}
      <div className="col-lg-4">
        <div className="thumb mb-3">
          <div className="skeleton skeleton-img" style={{width: "100%", height: "200px"}}></div>
        </div>

        <div className="row g-3">
          <div className="col-4">
            <div className="thumb">
              <div className="skeleton skeleton-img" style={{aspectRatio: "1/1", width: "100%", height: "100%"}}></div>
            </div>
          </div>
          <div className="col-4">
            <div className="thumb">
              <div className="skeleton skeleton-img" style={{aspectRatio: "1/1", width: "100%", height: "100%"}}></div>
            </div>
          </div>
          <div className="col-4">
            <div className="thumb d-flex align-items-center justify-content-center" style={{minHeight: 96}}>
              <div className="skeleton skeleton-btn" style={{width: "100%", height: "40px"}}></div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section> :

<>


<style>{`
  :root{
    --navy:#0B2E4A;
    --line:#e9eef5;
    --primary:#0d6efd;
  }
  .page-hero{
    background:linear-gradient(180deg, rgba(13,110,253,.06), #fff);
    border-bottom:1px solid var(--line);
  }
  .glass{
    background:rgba(255,255,255,.90);
    backdrop-filter: blur(10px);
    border:1px solid var(--line);
    border-radius:20px;
    box-shadow: 0 14px 34px rgba(0,0,0,.06);
  }
  .pill{
    border:1px solid #e6edf7; background:#fff;
    border-radius:999px; padding:8px 12px; font-size:13px;
    display:inline-flex; align-items:center; gap:8px; white-space:nowrap;
  }
  .star{ color:#F4B400; }
  .thumb{ border-radius:16px; overflow:hidden; border:1px solid var(--line); background:#f7fafc; }
  .sticky-side{ position:sticky; top:90px; }
  .cta-btn{ border-radius:999px; font-weight:700; padding:.7rem 1rem; }
  .navtabs .nav-link{
    border:1px solid var(--line);
    border-radius:999px;
    padding:.55rem 1rem;
    color:#334155;
    background:#fff;
  }
  .navtabs .nav-link.active{
    background:rgba(13,110,253,.08);
    border-color:rgba(13,110,253,.30);
    color:#0b5ed7;
    font-weight:700;
  }
`}</style>

{/* ===================== SINGLE DOCTOR VIEW PAGE ===================== */}
<section className="page-hero py-5">
  <div className="container">

  {isOpen && (
                <>
                  <div class="propop">
                    <i onClick={togglePopup} class="ri-close-line" type="button" ></i>

                    <Swiper
                      style={{
                        "--swiper-navigation-color": "#335599",
                        "--swiper-pagination-color": "#335599",
                        "padding-bottom": "40px",
                      }}
                      spaceBetween={10}
                      navigation={true}
                      pagination={true}
                      modules={[FreeMode, Navigation, Pagination]}
                      className="mySwiper2  "
                    >

          {Array.from({ length: 8 }, (_, i) => Page?.[`Doc${i + 3}`]) // Doc3 → Doc10
  .filter(Boolean) // remove null, undefined, empty
  .map((imgSrc, index) => (
    <SwiperSlide key={index} className='w-100'>
      <div className='d-block'>
     <img
        src={weburl+imgSrc}
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = '/assets/img/placeholder.png';
        }}
        className="w-100 object-fit-contain"
        alt={`Image ${index + 1}`}
        style={{ aspectRatio: '1 / 1' }}
      />
      </div>
 
    </SwiperSlide>
  ))}


  
                    </Swiper>
                  </div>
                </>
              )}


    {/* Breadcrumb */}
    <div className="small text-muted mb-3">
      Home <span className="mx-1">›</span> Doctors <span className="mx-1">›</span>
      <span className="fw-semibold text-dark">Dr. Abhiruchi Gupta</span>
    </div>

    <div className="row g-4 align-items-start">

      {/* LEFT: Doctor Info */}
      <div className="col-lg-4">
        <div className="glass p-4">

          {/* Doctor's Image and Basic Info */}
          <div className="d-flex align-items-start gap-3 mb-4">
            <img src={
                              Page &&
                                typeof Page.profile === "string" &&
                                Page.profile !== ""
                                ? weburl + Page.profile.replace("public", "")
                                : "/assets/img/placeholder.png"
                            }
                            onError={(e) =>
                              (e.target.src = "/assets/img/placeholder.png")
                            } 
                            style={{width:100}}
                            className="rounded-circle" alt="Doctor" />
            <div>
              <div className="fw-bold fs-4" style={{color:"var(--navy)"}}>
              {Page?.username}
              </div>
              <div className="text-muted small">
                
                   {Page?.subDepartments && Page?.subDepartments.map((department, index) => (
                    <>{department} • {' '}
                    </> ) )}
              </div>
       
              <div className="text-muted small">📍  {Page.statename} </div>
            </div>
          </div>

          {/* Rating + Experience */}
          <div className="d-flex gap-2 mb-3">
            <div className="pill">
              <span className="fw-bold"> <img width={20} src="/assets/img/google-logo.svg"/> </span>
              <span className="fw-bold">{safeRating.toFixed(1)}</span>
              <span className="star fs-sm">{starsText}</span>
            </div>
            <div className="pill"> {Page.Experience}+ Yr Experience</div>
            <div className="pill">✔ Verified</div>
          </div>

          {/* Doctor Description */}
          <div className="fw-semibold mb-0">Education</div>
          <div className="text-muted small mb-4">
 
    {Page.educationList && Page.educationList.length > 0 && (

   <div className="mb-4">
      
      <ul className="  ps-5 mt-3">
        {Page.educationList.map((education, index) => (
          <li className=" " key={index}>
             {education}
          </li>
        ))}
      </ul>
        </div>
 

    )  }

           </div>

      
        </div>
      </div>

      {/* RIGHT: Sticky Sidebar */}
      <div className="col-lg-4">
        <div className="sticky-side">
          <div className="glass p-4">

            <div className="fw-bold" style={{color:"var(--navy)"}}>Book a Slot</div>
            <div className="text-muted small mb-3">
              Get priority appointment confirmation within minutes.
            </div>
 
 
        <div   className=" mb-1">
           
          <div className="card-body">

            <div className="d-flex gap-2 justify-content-between align-items-center border-bottom pb-4">

 
{clinicData.headId.filter(clinic => clinic._id === formData.hospitalId ).map(clinic => (
 <h4 className="small">{clinic.username}</h4> 
))}


         <div className="dropdown">
  <button
    className="btn bg-primary bg-sm rounded text-white small border-0 px-2 py-1 dropdown-toggle"
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
   Change Hospital
  </button>
  <ul className="dropdown-menu p-0 overflow-hidden">
    
    {clinicData.headId.map(clinic => (
    <li onClick={()=>{ 
               setFormData((prevData) => ({
            ...prevData,
            hospitalId: clinic._id
        })) 
           }}  type="button">
      <div className={`py-2 px-3 small ${clinic._id === formData.hospitalId && 'bg-dark text-white' }`}  >
        {clinic.username}
      </div>
    </li>
))}

 
    
  </ul>
</div>


</div>

<p className="small text-center py-2">Book an appointment for Consultation </p>
      
      {loadingBookings ?
      <div className="mt-3"> 
         
               <div className="d-flex gap-2 mb-2">
                 <div className="skeleton"
                  style={{
                    borderRadius: 5,
                     minWidth: 30,
                    height: 50,
                  }} />

                <div className="skeleton"
                  style={{
                    borderRadius: 5,
                    width: "100%",
                    height: 50,
                  }} />
                  <div className="skeleton"
                  style={{
                    borderRadius: 5,
                    width: "100%",
                    height: 50,
                  }} />
                   <div className="skeleton"
                  style={{
                    borderRadius: 5,
                    width: "100%",
                    height: 50,
                  }} />
                  <div className="skeleton"
                  style={{
                    borderRadius: 5,
                     minWidth: 30,
                    height: 50,
                  }} />

          </div>

 <div className="d-flex gap-2 mb-2">
               
                <div className="skeleton"
                  style={{
                    borderRadius: 5,
                    width: "100%",
                    height: 50,
                  }} />
                   <div className="skeleton"
                  style={{
                    borderRadius: 5,
                    width: "100%",
                    height: 50,
                  }} /> 
          </div>

           </div>: 
      <SchedulePicker  
      scheduleList={allBookings}
      employeeId={Page?._id}
      employee={Page}
      employeeName={Page?.username}
      
 onConfirm={({ date, time }) => {
  if (!time) return;

  const [start, end] = time.split("-") || [];

  const startTime24 = start ? to24Hour(start) : '';
  const endTime24 = end ? to24Hour(end) : '';

  setAddProduct(prev => {
    const updated = [...prev];

    // ensure first index exists
    if (!updated[0]) {
      updated[0] = {};
    }

    updated[0] = {
      ...updated[0],
      date,
      time,
      startTime: startTime24,
      endTime: endTime24,
      employee: {label:Page?.username,value:Page?._id,data:Page},
      employeeId: Page?._id,
      doctor: 1,
      total: Page.Salary,
    };

    console.log("Updated Array:", updated);
    return updated;
  });
setSelectedDate(date);
setSelectedTime(time);
 
  toast.success("Date & time selected");
}}

       />
          
      }
             

             <button
                              className="btn btn-primary bg-dark btn-shadow d-block w-100 rounded mb-3"
                              type="button"
                              onClick={dateTimeToggle}
                            >
                              Book Appointment
                            </button>


        </div>

    </div>
 
            <div className="small text-muted mt-3">
              By booking, you agree to terms & privacy policy.
            </div>

          </div>
        </div>
      </div>

      {/* CENTER: Doctor Gallery */}
      <div className="col-lg-4">
        
        
        
        
                  <div className="thumb mb-3" type="button" onClick={togglePopup}  >
                    <img  className="img-fluid  object-fit-cover object-center w-100 h-100" alt="hospital"  
                      src={
                                                        Page &&
                                                          typeof Page.profile === "string" &&
                                                          Page.profile !== ""
                                                          ? weburl + Page.profile
                                                          : "/assets/img/placeholder.png"
                                                      }
                                                      onError={(e) =>
                                                        (e.target.src = "/assets/img/placeholder.png")
                                                      }
                                                       />
                  </div>
        
                  <div className="row g-3">
                    <div className="col-4">
                      <div className="thumb w-100 h-auto"  type="button" onClick={togglePopup}  style={{aspectRatio:'1/1'}} >
                        <img className="img-fluid  object-fit-cover object-center w-100 h-100" alt="gallery" 
                        src={
                                                        Page &&
                                                          typeof Page.Doc4 === "string" &&
                                                          Page.Doc4 !== ""
                                                          ? weburl + Page.Doc4
                                                          : "/assets/img/placeholder.png"
                                                      }
                                                      onError={(e) =>
                                                        (e.target.src = "/assets/img/placeholder.png")
                                                      }
                                                        style={{aspectRatio:'1/1'}}/>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="thumb w-100 h-auto"  type="button" onClick={togglePopup}   style={{aspectRatio:'1/1'}} >
                        <img className="img-fluid w-100 h-100 object-fit-cover object-center" alt="gallery" 
                              src={ 
                                  Page &&
                                                          typeof Page.Doc5 === "string" &&
                                                          Page.Doc5 !== ""
                                                          ? weburl + Page.Doc5
                                                          : "/assets/img/placeholder.png"
                                                      }
                                                      onError={(e) =>
                                                        (e.target.src = "/assets/img/placeholder.png")
                                                      }
                                                      />
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="thumb d-flex align-items-center justify-content-center position-relative w-100 h-auto" style={{minHeight:96,aspectRatio:'1/1'}}  type="button" onClick={togglePopup}  >
                          <img className="img-fluid w-100 h-100  position-absolute object-fit-cover object-center object-center" alt="gallery" 
                           src={ 
                                  Page &&
                                                          typeof Page.Doc6 === "string" &&
                                                          Page.Doc6 !== ""
                                                          ? weburl + Page.Doc6
                                                          : "/assets/img/placeholder.png"
                                                      }
                                                      onError={(e) =>
                                                        (e.target.src = "/assets/img/placeholder.png")
                                                      }
                                                             style={{aspectRatio:'1/1'}}/>
                         <button className="btn btn-light border rounded-pill z-1 btn-sm">View All <i className="ri-arrow-right-line" /> </button>
                      </div>
                    </div>
                  </div>
        
              



      </div>

    </div>
  </div>
</section>

{/* ===================== TABS: DOCTOR DETAILS ===================== */}
<section className="py-5">
  <div className="container">
    <ul className="nav nav-pills gap-2 navtabs flex-wrap">
      <li className="nav-item"><a className="nav-link active" href="#overview">Overview</a></li>
      <li className="nav-item"><a className="nav-link" href="#expertise">Expertise</a></li>
      <li className="nav-item"><a className="nav-link" href="#availability">Availability</a></li>
      <li className="nav-item"><a className="nav-link" href="#reviews">Reviews</a></li>
      <li className="nav-item"><a className="nav-link" href="#faq">FAQ</a></li>
    </ul>
  </div>
</section>

{/* OVERVIEW */}
<section id="overview" className="py-5">
  <div className="container">
    <div className="row g-4">
      <div className="col-lg-8">
        <div className="glass p-4">
          <h5 className="fw-bold mb-2" style={{color:"var(--navy)"}}>About Dr. Abhiruchi Gupta</h5>
                            <div dangerouslySetInnerHTML={{ __html: Page.about }} />

        </div>
      </div>

      <div className="col-lg-4">
        <div className="glass p-4">
          <h6 className="fw-bold mb-3" style={{color:"var(--navy)"}}>Professional Highlights</h6>
          <div className="w-100">

            {Page?.subDepartments && Page?.subDepartments.map((department, index) => (
          <span key={index} className="pill bg-light me-2" >{department}</span>
        ))}
            
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

 

{/* REVIEWS */}
<section id="reviews" className="py-5 bg-light">
  <div className="container">
    <h5 className="fw-bold mb-3" style={{color:"var(--navy)"}}>Patient Reviews</h5>

     <span className="ms-0 mb-2 d-block">
                            {" "}
                            Help other customers make their decision{" "}
                          </span>

      <button
                            className="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
                            type="button"
                            onClick={toggleReviewPopup}
                          >
                            <i className="ri-add-line me-1" />
                            Write a Review
                          </button>

     {isOpenReview && (
                            <>
                              <div className="custom-popup ">
                                <div className="popup-container ">
                                  <button
                                    className="btn btn-danger btn-sm d-flex align-items-center justify-content-center"
                                    type="button"
                                    onClick={toggleReviewPopup}
                                  >
                                    <i className="ri-close-line" />
                                  </button>

                                  <div className="card border-0">
                                    <div className="card-body border-0">
                                      <h4 className="mb-2">
                                        Review And Rating
                                      </h4>
                                      <div className="needs-validation">
                                        <div className="mb-4">
                                          <label
                                            className="form-label"
                                            htmlFor="review-rating"
                                          >
                                            How was your experience
                                          </label>

                                          <div className="d-flex gap-2 ratingbox">
                                            <input
                                              type="radio"
                                              onChange={handleChange}
                                              name="rating"
                                              id="rating5"
                                              defaultValue="5"
                                              className="d-none"
                                            />
                                            <label htmlFor="rating5">
                                              <i className="ri-star-fill" />{" "}
                                            </label>

                                            <input
                                              type="radio"
                                              onChange={handleChange}
                                              name="rating"
                                              id="rating4"
                                              defaultValue="4"
                                              className="d-none"
                                            />
                                            <label htmlFor="rating4">
                                              <i className="ri-star-fill" />{" "}
                                            </label>

                                            <input
                                              type="radio"
                                              onChange={handleChange}
                                              name="rating"
                                              id="rating3"
                                              defaultValue="3"
                                              className="d-none"
                                            />
                                            <label htmlFor="rating3">
                                              <i className="ri-star-fill" />{" "}
                                            </label>

                                            <input
                                              type="radio"
                                              onChange={handleChange}
                                              name="rating"
                                              id="rating2"
                                              defaultValue="2"
                                              className="d-none"
                                            />
                                            <label htmlFor="rating2">
                                              <i className="ri-star-fill" />{" "}
                                            </label>

                                            <input
                                              type="radio"
                                              onChange={handleChange}
                                              name="rating"
                                              id="rating1"
                                              defaultValue="1"
                                              className="d-none"
                                            />
                                            <label htmlFor="rating1">
                                              <i className="ri-star-fill" />{" "}
                                            </label>
                                          </div>
                                        </div>
                                        <div className="mb-4">
                                          <label
                                            className="form-label"
                                            htmlFor="review-text"
                                          >
                                            Review<span>*</span>
                                          </label>
                                          <textarea
                                            className="form-control"
                                            rows={5}
                                            maxLength={300}
                                            name="comment"
                                            id="review-text"
                                            value={formData.comment}
                                            onChange={handleChange}
                                          />
                                          <div className="invalid-feedback">
                                            Please leave your review.
                                          </div>
                                        </div>

                                        {SubmitLoading ? (
                                          <button
                                            className="btn btn-primary"
                                            type="button"
                                            onClick={submitData}
                                          >
                                            Add Review
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-secondary btn-sm"
                                            type="button"
                                            disabled
                                          >
                                            <span className="ms-1">Loading...</span>
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
 

    <div className="row mt-4">
      {reviewItems && reviewItems.length > 0 ? (
        reviewItems.map((item, index) => {
          const ratingValue = Number(item.rating ?? 5);
          const solidStars = "★".repeat(Math.round(ratingValue));
          const empty = "☆".repeat(5 - Math.round(ratingValue));
          const createdAt = item.createdAt ? new Date(item.createdAt) : new Date();
          const when = createdAt.toLocaleDateString();
          return (
            <div className="col-md-4" key={index}>
              <div className="glass p-4">
                <div className="small text-muted">{item.comment}</div>
                <div className="d-flex align-items-center gap-3 mt-3">
                  <span className="star">{solidStars + empty}</span>
                  <span className="text-muted small">
                    {item.username || "Anonymous"}, {when}
                  </span>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="col-12">
          <div className="glass p-4 text-center">
            <div className="small text-muted">No reviews yet. Be the first to review.</div>
          </div>
        </div>
      )}
    </div>
  </div>
</section>

{/* FAQ */}
<section id="faq" className="py-5">
  <div className="container">
    <h5 className="fw-bold mb-3" style={{color:"var(--navy)"}}>Frequently Asked Questions</h5>
    <div className="accordion" id="faqAcc">
      {faqItems.map((faq, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#faq${index}`}
              aria-expanded={index === 0 ? 'true' : 'false'}
            >
              {faq.question}
            </button>
          </h2>
          <div
            id={`faq${index}`}
            className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
            data-bs-parent="#faqAcc"
          >
            <div className="accordion-body">{faq.answer}</div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

               
      <div
        className="modal enquire fade show"
        style={{ display: ChooseDateTime ? "block" : "none",backgroundColor:'#0000003b' }}
        id="exampleModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
       >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header py-0 d-flex justify-content-between">
              <h5 className="modal-title" id="exampleModalLabel">
                Book Appointment
              </h5>
              <button
                type="button"
                className="border-0 close bg-transparent h3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={dateTimeToggle}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className={`modal-body ${!isUserAuthenticated && 'bg-light'}`}>


              <div className="row">
      <div className="col-12">



 {isuser ? 
 <>

   {/* <h5>When should the professional arrive?</h5>
<p>Service will take approx. 45 mins</p> */}

{/* 
<ul className="customradio input-group two-grid mb-4 px-0 mx-0">
  {generateDates().map((date) => (
    <li key={date.value}>
      <input
        type="radio"
        id={`date-${date.value}`}
        name="bookingDate"
        value={date.value}
        checked={selectedDate === date.value}
        onChange={() => setSelectedDate(date.value)}
      />
      <label htmlFor={`date-${date.value}`}>
        {date.label}
      </label>
    </li>
  ))}
</ul>



 <p className="mt-3">Select start time of service</p>
<ul className="customradio input-group two-grid mb-4 px-0 mx-0">
  {timeSlots.map((slot) => (
    <li key={slot}>
      <input
        type="radio"
        id={`time-${slot}`}
        name="bookingTime"
        value={slot}
        checked={selectedTime === slot}
        onChange={() => setSelectedTime(slot)}
      />
      <label htmlFor={`time-${slot}`}>
        {slot}
      </label>
    </li>
  ))}
</ul> */}

  <div className="row">
                            {/* Name input */}
                            <div
                              data-mdb-input-init=""
                              className="form-outline mb-4"
                            >
                              <label
                                className="form-label"
                                htmlFor="form5Example1"
                              >
                                Full Name{" "} {enquireData.fullname}
                                <span className="text-danger">
                                  {" "}
                                  *
                                </span>
                              </label>
                              <input
                                type="text"
                                name="fullname"
                                id="form5Example1"
                                className="form-control"
                                value={enquireData.fullname}
                                onChange={handleEnquireChange}
                                style={{
                                  boxShadow: "none",
                                }}
                              />
                            </div>
                            {/* Email input */}
                            <div
                              data-mdb-input-init=""
                              className="form-outline col-md-6 mb-4"
                            >
                              <label
                                className="form-label"
                                htmlFor="form5Example2"
                              >
                                Phone No.{" "} 
                                <span className="text-danger">
                                  {" "}
                                  *
                                </span>
                              </label>
                              <input
                                type="number"
                                id="form5Example2"
                                className="form-control"
                                name="phone"
                                value={enquireData.phone}
                                onChange={handleEnquireChange}
                                style={{
                                  boxShadow: "none",
                                }}
                              />
                            </div>

                            <div 
                              className="form-outline col-md-6 mb-4"
                            >
                              <label
                                className="form-label"
                                htmlFor="form5Example2"
                              >
                                Email address{" "}
                                <span className="text-danger">
                                  {" "}
                                  *
                                </span>
                              </label>
                              <input
                                type="email"
                                id="form5Example2"
                                className="form-control"
                                name="email"
                                value={enquireData.email}
                                onChange={handleEnquireChange}
                                style={{
                                  boxShadow: "none",
                                }}
                              />
                            </div>

                            <div 
                              className="form-outline col-md-4 col-6 mb-4"
                            >
                              <label
                                className="form-label"
                                htmlFor="age"
                              >
                               Age
                                <span className="text-danger">
                                  {" "}
                                 *
                                </span>
                              </label>
                              <input
                                type="text"
                                 className="form-control"
                                name="age"
                                value={enquireData.age}
                                onChange={handleEnquireChange}
                                style={{
                                  boxShadow: "none",
                                }}
                                id="age"
                              />
                            </div>



<div 
                              className="form-outline col-md-4 col-6 mb-4"
                            >
                              <label
                                className="form-label"
                                htmlFor="weight"
                              >
                               Weight
                                <span className="text-danger">
                                  {" "}
                                  *
                                </span>
                              </label>
                              <input
                                type="weight"
                                id="weight"
                                className="form-control"
                                name="weight"
                                value={enquireData.weight}
                                onChange={handleEnquireChange}
                                style={{
                                  boxShadow: "none",
                                }}
                              />
                            </div>




<div className="mb-4 col-md-4 col-6 ">
                    <label className="form-label text-dark" htmlFor="email">
                      Gender  <span className="text-danger"> *</span>
                    </label>
                    <div className="input-group    input-sm">
                      <select
                        className="form-control"
                        value={enquireData.gender}
                        name="gender"
                        onChange={handleEnquireChange}
                      >
                        <option selected value="">
                          {" "}
                          Select Gender
                        </option>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                        <option value="0">Other</option>
                      </select>
                    </div>
                  </div>




                            <div
                              data-mdb-input-init=""
                              className="form-outline mb-4"
                            >
                              <label
                                className="form-label"
                                htmlFor="form5Example2"
                              >
                                Requirement
                                <span className="text-danger">
                                  {" "}
                                  *
                                </span>
                              </label>
                              <textarea
                                type="text"
                                id="requirement"
                                className="form-control"
                                name="requirement"
                                value={enquireData.requirement}
                                onChange={handleEnquireChange}
                                style={{
                                  boxShadow: "none",
                                }}
                              />
                            </div>
                          </div>

</> 
: <LoginComponents updateAuth={handleAuthUpdate} />
 }
       


  </div>
    
{/* 
  <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                  Booking Date
                    <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="date"
                    id="form5Example2"
                    className="form-control"
                    name="bookingDate"
                    value={dateTimeData.bookingDate}
                    onChange={handleDateTimeChange}
                    style={{ boxShadow: "none" }}
                        

                  />
                </div>
 
                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                     Booking Time
                    <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="time"
                    id="form5Example2"
                    className="form-control"
                    name="bookingTime"
                    value={dateTimeData.bookingTime}
                    onChange={handleDateTimeChange}
                    style={{ boxShadow: "none" }}
                     
                  />
                </div>
  */} 
  
</div>
            </div>
     {isuser &&         <div className="modal-footer">

      <div className="d-flex gap-2 justify-content-between ps-3">
                       

  <button
                           className="btn bg-dark text-white d-flex align-items-center justify-content-center w-100"
                          type="button"
                            data-dismiss="modal"
                        aria-label="Close"
onClick={() => { BookAppointment(); dateTimeToggle(); }}
                        >
                          <i className="ri-shopping-cart-2-line text-white" />
                          <span className="d-sm-inline ms-2 text-white">
                            Book Now
                          </span>
                        </button>  
 
                      </div>

              {/* <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={enquireToggle}
              >
                Close
              </button> */}
              {/* <button
                type="button"
                className="btn btn-primary"
                onClick={handleSendEnquire}
                disabled={EnquireStatus} // Properly use the `disabled` attribute
              >
                Submit
              </button> */}

            </div>
            }

          </div>
        </div>
      </div>


</>
} 



 

      <Footer />
    </>
  );
};

export default ViewVendor;
